import { render, staticRenderFns } from "./AgencyChooseProjectTypeEmpty.vue?vue&type=template&id=4a988f7d&scoped=true&"
import script from "./AgencyChooseProjectTypeEmpty.vue?vue&type=script&lang=js&"
export * from "./AgencyChooseProjectTypeEmpty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a988f7d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib'
installComponents(component, {VSelect})
